export { default } from "./SectionTitle-component";
